<template>
  <div class="data-table-panel-v">
    <DataGrid size="mini"
              resizable
              :data="data">
      <DataGridColumn v-for="(column, index) in columns"
                      :key="index"
                      :field="column.field"
                      :title="column.title"
                      :width="column.width"
                      :align="column.align || 'left'"/>
    </DataGrid>
  </div>
</template>

<script>
import DataGrid from '../../DataGrid'
import DataGridColumn from '../../DataGridColumn'
export default {
  name: 'TablePanel',
  components: { DataGrid, DataGridColumn },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    data: Array
  }
}
</script>

<style lang="scss" scoped>
.data-table-panel-v {
  height: 100%;
  padding: 12px;
  background-color: #fff;
}
</style>
